import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';

class ModalChangeControlStore {
    @observable modalOpenState = false;
    /**
     * 修改弹窗打开的状态
     * @param state
     */
    onSetModalOpenState = state => {
        this.modalOpenState = state;
    };

    use() {
        useMount(() => { });
    }
}

const GlobalModalOpenControl = new ModalChangeControlStore();

export default GlobalModalOpenControl;
